import { CommCenterTicketId } from "../../../messages";

export const chatRoomQueryKey = (id: CommCenterTicketId) => ["comm_center", "tickets", id];
